export default "__VITE_ASSET__DQFVf3aH__"